export default __webpack_public_path__ + "static/media/box.4c3adefa.svg";